/**
 * Permission constants used in the Sidebar component
 */
export const PERMISSIONS = {
    // Rate Maintenance Permissions
    TRANSFER_STATION_RATE_MAINTENANCE: "TRANSFER_STATION_RATE_MAINTENANCE",
    REGULAR_RATE_MAINTENANCE: "REGULAR_RATE_MAINTENANCE",
    CUSTOM_RATE_SEARCH: "CUSTOM_RATE_SEARCH",
    MANAGE_MINIMUM_WEIGHT_AND_RATE: "MANAGE_MINIMUM_WEIGHT_AND_RATE",
    MANAGE_RATE_MAINTENANCE: "MANAGE_RATE_MAINTENANCE",
    MANAGE_JURISDICTION_DETAILS: "MANAGE_JURISDICTION_DETAILS",
    MANAGE_SPECIAL_SERVICE_RATE: "MANAGE_SPECIAL_SERVICE_RATE",
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;
export type PermissionValue = typeof PERMISSIONS[PermissionKey];
